export default [
  { title: 'Balances', routeName: 'finance-balances' },

  { title: 'Wallets', routeName: 'finance-wallets' },
];
